export default "__VITE_ASSET__cac4d549__"